import NextLink from 'next/link';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

import { TabNav, TabNavItem } from 'shopper/components/TabNav';

import { sendEvent } from 'lib/gtag';
import { stripQs } from 'lib/request';
import { noop } from 'lib/utils';

import STORES from 'constants/store';

const StoresTabNav = ({
  activeTabName,
  className,
  onTabClickCallback = noop,
  ...rest
}) => {
  const router = useRouter();

  const onTabClick = (tabClicked) => {
    sendEvent({
      category: 'stores_full_list',
      action: `${tabClicked.tabName.toLowerCase()}_tab`,
    });

    onTabClickCallback(tabClicked);
  };

  return (
    <TabNav className={twMerge('mb-10 justify-center', className)} {...rest}>
      {Object.values(STORES.TABS).map(({ tabName, url }) => {
        const TabNavItemWithProps = (
          <TabNavItem
            key={tabName}
            active={tabName === activeTabName}
            aria-label={tabName}
            className="w-1/3"
            size="size1"
            onClick={() => onTabClick({ tabName, url })}
          >
            {tabName}
          </TabNavItem>
        );

        if (url === stripQs(router.asPath)) {
          return TabNavItemWithProps;
        }

        return (
          <NextLink key={tabName} href={url} prefetch={false} passHref>
            {TabNavItemWithProps}
          </NextLink>
        );
      })}
    </TabNav>
  );
};

StoresTabNav.propTypes = {
  activeTabName: PropTypes.string.isRequired,
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  onTabClickCallback: PropTypes.func,
};

export default StoresTabNav;
